export const ORIGENS_LEAD = [
  'Indicação',
  'Prospecção ativa',
  'Evento',
  'Mídia digital',
  'Site',
  'Parceiro',
  'ERP expirado',
  'Outro',
];
